import { PDFLink } from 'components/RevxPDFLink';
import jobService from 'services/jobService';
import { JobItem, PDF_TEMPLATE_ENUM } from 'domains/workspaceDomain';
import { useTranslation } from 'react-i18next';
import { useOrg, useRole } from 'hooks';
import useJobCardInfo from '../../hooks/useJobCardInfo';

const CardInfoPDFLinks = (data: JobItem) => {
  const { t } = useTranslation();
  const org = useOrg();
  const { isInternalJob, hasProducer } = useJobCardInfo(data);
  const { supplierRole } = useRole();

  const { id, quoteId } = data;
  if (
    !(
      supplierRole &&
      org?.supplierViewJobSummary &&
      hasProducer &&
      isInternalJob
    )
  ) {
    return <></>;
  }
  return (
    <>
      <PDFLink
        link={jobService.getPdfLink({
          jobId: id,
          jobConfigId: quoteId,
          template: PDF_TEMPLATE_ENUM.JOB_SUMMARY,
        })}
        title={t('workspace.pdfTitle.priceSummary')}
      />
    </>
  );
};

export default CardInfoPDFLinks;
